import { register } from '../../../JavaScript/Utils'

const AnchorNavigation = el => {
  const links = el.querySelectorAll('a')

  const onClick = e => {
    e.preventDefault()

    const targetElement = document.querySelector(e.currentTarget.getAttribute('href'))
    const headerOffset = 120
    const elementPosition = targetElement.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    })
  }

  links.forEach(link => {
    link.addEventListener('click', onClick)
  })
}

register('AnchorNavigation', AnchorNavigation)
